import { useState, useEffect } from 'react';
import Union from '../../styles/images/Union.png';
/**
 * 瀑布流布局组件 - 传统实现
 * @param {Object} props
 * @param {Array} props.items - 要渲染的项目数组，每个项目应包含 { type, key, component }
 * @param {number} props.columns - 列数，默认为4
 * @param {string} props.gap - 间距，默认为 'gap-4'
 * @param {Object} props.heightMap - 高度映射，如 { 'social': '10rem', 'post': '20rem' }
 */
const WaterfallLayout = ({
  items = [],
  columns = 4,
  gap = 'gap-4',
  heightMap = { social: '10rem', post: '20rem', friend: '20rem' },
}) => {
  const [columnData, setColumnData] = useState([]);

  useEffect(() => {
    if (!items.length) {
      setColumnData([]);
      return;
    }

    // 初始化列数组
    const newColumns = Array.from({ length: columns }, () => []);
    const columnHeights = Array.from({ length: columns }, () => 0);

    items.forEach((item) => {
      // 找到高度最小的列
      let minHeight = columnHeights[0];
      let minIndex = 0;

      for (let i = 1; i < columnHeights.length; i++) {
        if (columnHeights[i] < minHeight) {
          minHeight = columnHeights[i];
          minIndex = i;
        }
      }

      newColumns[minIndex].push(item);

      // 根据卡片类型获取高度
      let cardHeight = 0;
      if (item.type === 'social') {
        cardHeight = 160; // 10rem = 160px
      } else if (item.type === 'post' || item.type === 'friend-with-image') {
        cardHeight = 320; // 20rem = 320px
      } else if (item.type === 'friend-without-image') {
        cardHeight = 160; // 10rem = 160px (h-40)
      } else if (item.type === 'team') {
        cardHeight = 180; // 16rem = 256px
      } else {
        cardHeight = 320; // 默认高度
      }

      // 添加间距（gap-4 = 16px）
      columnHeights[minIndex] += cardHeight + 16;
    });

    setColumnData(newColumns);
  }, [items, columns]);

  return (
    <div className={`flex ${gap}`}>
      {columnData.length === 0 && (
        <div className="flex-1 flex flex-col gap-2">
          <div className="w-full flex flex-col justify-center items-center">
            <img src={Union} alt="no data" className="w-1/10 pb-2" />
            <span className="text-sm text-gray-500">暂无内容</span>
          </div>
        </div>
      )}
      {columnData.map((column, columnIndex) => (
        <div key={columnIndex} className="flex-1 flex flex-col gap-4">
          {column.map((item) => (
            <div key={item.key} className="w-full">
              {item.component}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default WaterfallLayout;
